import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
function DashboardListing() {
  return (
    <>
      {[1, 2].map((item) => (
        <div className="col-12 mt-3" key={item}>
          <div className="program-listing">
            <div className="each-list-program">
              <div className="program-header">
                <h3 className="programe-list-title">
                  10-Day Embodying True Nature Intensive · Oct 21 - 31, 2023
                </h3>

                <div className="d-flex align-items-center">
                  <button className="btn programe-list-btn">
                    Pre Screening
                  </button>
                </div>
              </div>
              <div className="program-content ">
                <div className="programe-content-main row">
                  <div className="col-12 col-md-7 col-lg-6 d-flex flex-column flex-md-row align-items-center ps-0">
                    <div className="programe-media me-3 h-100">
                      <img
                        className="h-100"
                        src="https://cdn.pixabay.com/photo/2015/12/01/20/28/road-1072823_640.jpg"
                        alt="programe"
                      />
                    </div>
                    <ul className="listing-info listing-info-first">
                      <li>
                        <span>type</span>
                        <strong>Fixed Timings</strong>
                      </li>
                      <li>
                        <span>category</span>
                        <strong>{item.categoryId?.title}</strong>
                      </li>

                      <li>
                        <span>status</span>
                        <strong>Fixed Timings</strong>
                      </li>

                      <li>
                        <span>Organized By</span>
                        <strong>Fixed Timings</strong>
                      </li>
                      <li>
                        <span>Dates</span>
                        <strong>Oct 21 - 31</strong>
                      </li>
                    </ul>
                  </div>
                  <ul className="listing-info listing-info-second col-12 col-md-5 col-lg-6 pe-0">
                    <li>
                      <span>Guests</span>
                      <strong>
                        <strong>10</strong>/<strong>20</strong>
                      </strong>
                    </li>
                    <li>
                      <span>Forms Filled</span>
                      <strong>
                        <strong>10</strong>/<strong>20</strong>
                      </strong>
                    </li>
                    <li>
                      <span>Documents</span>
                      <strong>
                        <strong>10</strong>/<strong>20</strong>
                      </strong>
                    </li>
                    <li>
                      <span>Pre Screening</span>
                      <strong>
                        <strong>10</strong>/<strong>20</strong>
                      </strong>
                    </li>
                    <li>
                      <span>Pre Integration</span>
                      <strong>
                        <strong>10</strong>/<strong>20</strong>
                      </strong>
                    </li>
                    <li>
                      <span>Post Integration</span>
                      <strong>
                        <strong>10</strong>/<strong>20</strong>
                      </strong>
                    </li>
                    <li>
                      <span>Payment</span>
                      <strong>
                        <strong>$2,222</strong>/<strong>2,222</strong>
                      </strong>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}

      <Modal className="common-create-modal">
        <Container>
          <form>
            <Row>
              <Col md={12}>
                <div className="program-steps-card header-spacer">
                  <div className="form-wrap">
                    <Row>
                      <Col md={12} xl={6}>
                        <Form.Group
                          className="form-group"
                          controlId="ControlInput1"
                        >
                          <Form.Label id="ControlInput1">Title</Form.Label>
                          <Form.Control
                            type="text"
                            name="title"
                            placeholder="Type here..."
                          />
                        </Form.Group>
                      </Col>
                      <Col md={12} xl={6}>
                        <Form.Group
                          className="form-group"
                          controlId="ControlInput1"
                        >
                          <Form.Label id="ControlInput1">
                            Description
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="description"
                            placeholder="Type here..."
                          />
                        </Form.Group>
                      </Col>
                      <Col md={12} xl={6}>
                        <Form.Group
                          className="form-group"
                          controlId="ControlInput1"
                        >
                          <Form.Label id="ControlInput1">Category</Form.Label>

                          <Form.Control as="select">
                            {" "}
                            <option defaultValue>Please choose Category</option>
                            {[1, 2, 3].map((item, i) => (
                              <option key={i} className="text-dark">
                                Title
                              </option>
                            ))}
                          </Form.Control>
                        </Form.Group>
                      </Col>
                      <Col md={12} xl={6}>
                        <Form.Group
                          className="form-group"
                          controlId="ControlInput1"
                        >
                          <Form.Label id="ControlInput1">
                            Sub Category
                          </Form.Label>
                          <Form.Control as="select">
                            <option defaultValue>
                              Please choose Sub Category
                            </option>
                            {[1, 2, 3].map((item, i) => (
                              <option key={i} className="text-dark">
                                Title
                              </option>
                            ))}
                          </Form.Control>
                        </Form.Group>
                      </Col>

                      <Col md={12} xl={6}>
                        <Form.Group
                          className="form-group"
                          controlId="ControlInput1"
                        >
                          <Form.Label id="ControlInput1">Over View</Form.Label>
                          <Form.Control
                            type="text"
                            name="overView"
                            placeholder="Type here..."
                          />
                        </Form.Group>
                      </Col>

                      <Col md={12} xl={6}>
                        <Form.Group
                          className="form-group"
                          controlId="ControlInput1"
                        >
                          <Form.Label id="ControlInput1">Address</Form.Label>
                          <Form.Control
                            type="text"
                            name="address"
                            placeholder="Type here..."
                          />
                        </Form.Group>
                      </Col>

                      <Col md={12} xl={6}>
                        <Form.Group
                          className="form-group"
                          controlId="ControlInput1"
                        >
                          <Form.Label id="ControlInput1">city</Form.Label>
                          <Form.Control
                            type="text"
                            name="city"
                            placeholder="Type here..."
                          />
                        </Form.Group>
                      </Col>
                      <Col md={12} xl={6}>
                        <Form.Group
                          className="form-group"
                          controlId="ControlInput1"
                        >
                          <Form.Label id="ControlInput1">Country</Form.Label>
                          <Form.Control
                            type="text"
                            name="country"
                            placeholder="Type here..."
                          />
                        </Form.Group>
                      </Col>
                      <Col md={12} xl={6}>
                        <Form.Group
                          className="form-group"
                          controlId="ControlInput1"
                        >
                          <Form.Label id="ControlInput1">
                            Country Code
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="countryCode"
                            placeholder="Type here..."
                          />
                        </Form.Group>
                      </Col>

                      <Col md={12} xl={6}>
                        <Form.Group
                          className="form-group"
                          controlId="ControlInput1"
                        >
                          <Form.Label id="ControlInput1">
                            Postal Code
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="postal_code"
                            placeholder="Type here..."
                          />
                        </Form.Group>
                      </Col>
                      <Col md={12} xl={6}>
                        <Form.Group
                          className="form-group"
                          controlId="ControlInput1"
                        >
                          <Form.Label id="ControlInput1">State</Form.Label>
                          <Form.Control
                            type="text"
                            name="state"
                            placeholder="Type here..."
                          />
                        </Form.Group>
                      </Col>
                      <Col md={12} xl={6}>
                        <Form.Group
                          className="form-group"
                          controlId="ControlInput1"
                        >
                          <Form.Label id="ControlInput1">
                            Street Number
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="street_number"
                            placeholder="Type here..."
                          />
                        </Form.Group>
                      </Col>

                      <Col md={12} xl={6}>
                        <Form.Group
                          className="form-group"
                          controlId="ControlInput1"
                        >
                          <Form.Label id="ControlInput1">Image</Form.Label>
                          <Form.Control
                            type="file"
                            name="picURL"
                            placeholder="Type here..."
                          />
                        </Form.Group>
                      </Col>
                      <Col md={12} xl={6}>
                        <Form.Group
                          className="form-group"
                          controlId="ControlInput1"
                        >
                          <Form.Label id="ControlInput1">Start Date</Form.Label>
                          <Form.Control
                            type="date"
                            name="startDate"
                            format="YYYY-MM-DD"
                            placeholder="Type here..."
                          />
                        </Form.Group>
                      </Col>
                      <Col md={12} xl={6}>
                        <Form.Group
                          className="form-group"
                          controlId="ControlInput1"
                        >
                          <Form.Label id="ControlInput1">End Date</Form.Label>
                          <Form.Control
                            type="date"
                            name="endDate"
                            format="YYYY-MM-DD"
                            placeholder="Type here..."
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>

                  <div className="payment-footer">
                    <Row className="align-items-center w-100">
                      <Col md={12} lg={12} xl={6}>
                        <div className="action-btns mt-3 mt-xl-0 d-flex justify-content-xl-start">
                          <Button type="submit">Save</Button>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
            </Row>
          </form>
        </Container>
      </Modal>
    </>
  );
}

export default DashboardListing;
